const ADMIN = "admin";
const USER = "user";
const MANAGER = "manager";
const SUPERVISOR = "supervisor";
const ESTABLISHMENT_CREATOR = "establishment_creator";

export default { ADMIN, USER, MANAGER, SUPERVISOR, ESTABLISHMENT_CREATOR };
